// extracted by mini-css-extract-plugin
export default {"badgesup":"badgesup__DQmkqh","button":"button__8XnR_3"};